var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "b-col",
          [
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: { "label-cols-sm": "20", "label-cols-lg": "2" }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Nimi")))
                ]),
                _vm._v(" "),
                _vm.moveOutName
                  ? _c("span", [_vm._v(_vm._s(_vm.moveOutName))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER &&
                !_vm.moveOutName
                  ? _c("span", [_vm._v(_vm._s(_vm.moveOutCustomerName))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY &&
                !_vm.moveOutName
                  ? _c("span", [_vm._v(_vm._s(_vm.moveOutCompanyName))])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "20",
                  "label-cols-lg": "2",
                  "label-align-md": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Päätettävät sopimukset")))
                ]),
                _vm._v(" "),
                _vm._l(_vm.contract.MoveOutProcess.ConsumptionPoints, function(
                  ConsumptionPoint
                ) {
                  return _c(
                    "div",
                    _vm._l(ConsumptionPoint.MeteringPoints, function(
                      meteringPoint
                    ) {
                      return _c("p", { staticClass: "form-control-static" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              meteringPoint.MeteringPointAddress.StreetAddress
                            ) +
                            " (" +
                            _vm._s(meteringPoint.MeteringPointCode) +
                            " - " +
                            _vm._s(
                              _vm.utilityTypeString(
                                ConsumptionPoint.UtilityTypeId
                              )
                            ) +
                            "\n                        "
                        ),
                        ConsumptionPoint.UtilityTypeId == 1
                          ? _c("span", [
                              meteringPoint.SourceCompanyCode == "TEV"
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                , " +
                                        _vm._s(_vm.contractTypeString(2)) +
                                        "\n                            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              meteringPoint.SourceCompanyCode == "TEM"
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                , " +
                                        _vm._s(_vm.contractTypeString(1)) +
                                        "\n                            "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(")\n                    ")
                      ])
                    }),
                    0
                  )
                })
              ],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-col",
          [
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "12",
                  "label-cols-lg": "2",
                  "label-align-md": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Päättymispäivä")))
                ]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("date")(_vm.contract.MoveOutProcess.MoveOutDate)
                    )
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }